module.exports = __webpack_public_path__ + "static/media/favicon.c8657d62.ico";